import moment from 'moment';

function getCompanyTypes(input) {
	const totalIndustryTypes = ['GENERAL_INSURANCE', 'LIFE_INSURANCE', 'MICRO_INSURANCE'];
	if (input === '1') {
		return totalIndustryTypes;
	} else if (input === '2') {
		return ['GENERAL_INSURANCE'];
	} else if (input === '3') {
		return ['LIFE_INSURANCE'];
	} else if (input === '4') {
		return ['MICRO_INSURANCE'];
	} else if (input === '5') {
		return ['REINSURANCE'];
	}
	return totalIndustryTypes;
}

function getFilterTitle({ title, industrial }) {
	if (title === '1') {
		return industrial === true ? 'Total Industry' : 'Total Ews';
	} else if (title === '2') {
		return 'General Insurance';
	} else if (title === '3') {
		return 'Life Insurance';
	} else if (title === '4') {
		return 'Micro Insurance';
	} else if (title === '5') {
		return 'ReInsurance';
	}
	return '';
}

function getYear(input) {
	moment.locale('en-gb');
	return parseInt(input ? input : moment().format('YYYY'));
}

export { getCompanyTypes, getFilterTitle, getYear };
